export var NetworkType;
(function (NetworkType) {
    NetworkType["EVM"] = "evm";
    NetworkType["Starknet"] = "starknet";
    NetworkType["Solana"] = "solana";
    NetworkType["Cosmos"] = "cosmos";
    NetworkType["StarkEx"] = "starkex";
    NetworkType["TON"] = "ton";
    NetworkType["Fuel"] = "fuel";
    NetworkType["Bitcoin"] = "bitcoin";
    NetworkType["Tron"] = "tron";
    NetworkType["Stellar"] = "stellar";
    NetworkType["Hyperliquid"] = "hyperliquid";
    NetworkType["Polymarket"] = "polymarket";
})(NetworkType || (NetworkType = {}));
